const model = {
  'page_name': ''
}

export const gtm_view = (data: any) => {
  let final_data = {}
  final_data = JSON.parse(JSON.stringify(model))
  for (const property in data) {
    final_data[property] = data[property]
  }
  (window as any)?.dataLayer?.push(final_data)
}
